import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { useLoginContext } from "../context/LoginContext";
import { Formik } from "formik";
import { useMutation } from "@tanstack/react-query";
import { putRequest } from "../services/apiMethods";
import toast from "react-hot-toast";

export default function ContactPreferences() {
  const Navigate = useNavigate();
  const { userData, refresh } = useLoginContext();

  const initialValues = {
    leads: {
      emailNotification: false,
      pushNotification: false,
    },
    someoneViews: {
      emailNotification: false,
      pushNotification: false,
    },
    quoteCredits: {
      emailNotification: false,
      pushNotification: false,
    },
    accountUpdates: {
      emailNotification: false,
      pushNotification: false,
    },
    offersPromotion: {
      emailNotification: false,
      pushNotification: false,
    },
  };


  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
        return putRequest("/profile/setting", data);
    },
    onSuccess: (data) => {
        if (data?.statusCode == 200) {
          toast.success(`${data?.message}`, {
            iconTheme: {
                primary: '#337FE0',
                secondary: '#FFFAEE',
            },
        })
        refresh()
        }
    },
    onError: (error) => {
        console.error("Error during API call:", error);
    },
});



const handleSectionSubmit = (values, sectionName) => {
let payload 

if(sectionName == "leads"){
  payload = {
    leads: values?.leads,
    someoneViews: values?.someoneViews,
  };
}else if(sectionName == "accountUpdates"){
  payload = {
    quoteCredits: values?.quoteCredits,
    accountUpdates: values?.accountUpdates,
  };
}else{
  payload = {
    offersPromotion: values?.offersPromotion,
  };
}
  console.log("Submitting section:", sectionName, payload);
  mutate(payload);
};

  return (
    <Layout>
      <Container>
        <div className="dashboard-main">
          <h3 className="with-back-btn cursor-pointer" onClick={() => Navigate("/settings")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                fill="black"
              />
            </svg>
            Account
          </h3>
          <Row>
            <Col lg={8}>
              <div className="my-profile-card-contain">
                <div className="my-profile-title">
                  <h4>Contact Preferences</h4>
                  <p>Toggle your preferences on how we communicate with you.</p>
                </div>

                <Formik
                  enableReinitialize
                  initialValues={userData || initialValues}
                  onSubmit={(values) => {
                    // console.log("All Form Values33", values );
                  }}
                >
                  {({ values, setFieldValue  ,handleSubmit }) => (
                <div className="my-profile-box-contain">
                  {/* Leads & Responses */}
                  <div className="my-profile-box-form">
                    <div className="form-box-title">
                      <h4>Leads & Responses</h4>
                    </div>
                    <div className="contact-preferences">
                      <h5>New leads matching your services</h5>
                      <ul>
                        <li>
                          <p>Email notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="leads-email"
                            checked={values.leads.emailNotification}
                            onChange={() =>
                              setFieldValue("leads.emailNotification", !values.leads.emailNotification)
                            }
                          />
                        </li>
                        <li>
                          <p>Mobile push notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="leads-push"
                            checked={values.leads.pushNotification}
                            onChange={() =>
                              setFieldValue("leads.pushNotification", !values.leads.pushNotification)
                            }
                          />
                        </li>
                      </ul>
                    </div>
                    <div className="contact-preferences">
                      <h5>Someone views your profile</h5>
                      <ul>
                        {/* <li>
                          <p>Email notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="views-email"
                            checked={values.someoneViews.emailNotification}
                            onChange={() =>
                              setFieldValue("someoneViews.emailNotification", !values.someoneViews.emailNotification)
                            }
                          />
                        </li> */}
                        <li>
                          <p>Mobile push notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="views-push"
                            checked={values.someoneViews.pushNotification}
                            onChange={() =>
                              setFieldValue("someoneViews.pushNotification", !values.someoneViews.pushNotification)
                            }
                          />
                        </li>
                      </ul>
                    </div>
                    <div className="d-flex gap-4">
                      <button className="theme-comm-btn"   type="button"
                    //  onClick={() => handleSubmit()} 
                     onClick={() => handleSectionSubmit(values, "leads")}
                     
                     >
                        Update
                      </button>
                    </div>
                  </div>

                  {/* Account */}
                  <div className="my-profile-box-form">
                    <div className="form-box-title">
                      <h4>Account</h4>
                    </div>
                    <div className="contact-preferences">
                      <h5>Quote credits running low</h5>
                      <ul>
                        {/* <li>
                          <p>Email notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="credits-email"
                            checked={values.quoteCredits.emailNotification}
                            onChange={() =>
                              setFieldValue("quoteCredits.emailNotification", !values.quoteCredits.emailNotification)
                            }
                          />
                        </li> */}
                        <li>
                          <p>Mobile push notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="credits-push"
                            checked={values.quoteCredits.pushNotification}
                            onChange={() =>
                              setFieldValue("quoteCredits.pushNotification", !values.quoteCredits.pushNotification)
                            }
                          />
                        </li>
                      </ul>
                    </div>
                    <div className="contact-preferences">
                      <h5>Updates to your account</h5>
                      <ul>
                        <li>
                          <p>Email notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="account-email"
                            checked={values.accountUpdates.emailNotification}
                            onChange={() =>
                              setFieldValue("accountUpdates.emailNotification", !values.accountUpdates.emailNotification)
                            }
                          />
                        </li>
                        <li>
                          <p>Mobile push notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="account-push"
                  
                            checked={values.accountUpdates.pushNotification}
                                onChange={() =>
                                  setFieldValue("accountUpdates.pushNotification", !values.accountUpdates.pushNotification)
                                }
                          />
                        </li>
                      </ul>
                    </div>
                    <div className="d-flex gap-4">
                      <button className="theme-comm-btn"  type="button"
                      //  onClick={() => handleSubmit()}
                       onClick={() => handleSectionSubmit(values, "accountUpdates")}
                       >
                        Update
                      </button>
                    </div>
                  </div>

                  {/* Marketing */}
                  {/* <div className="my-profile-box-form">
                    <div className="form-box-title">
                      <h4>Marketing</h4>
                    </div>
                    <div className="contact-preferences">
                      <h5>New offers & promotions</h5>
                      <ul>
                        <li>
                          <p>Email notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="promo-email"
                            checked={values.offersPromotion.emailNotification}
                                onChange={() =>
                                  setFieldValue("offersPromotion.emailNotification", !values.offersPromotion.emailNotification)
                                }
                          />
                        </li>
                        <li>
                          <p>Mobile push notifications</p>
                          <Form.Check
                            type="switch"
                            className="custom-switch"
                            id="promo-push"
                            checked={values.offersPromotion.pushNotification}
                            onChange={() =>
                              setFieldValue("offersPromotion.pushNotification", !values.offersPromotion.pushNotification)
                            }
                          />
                        </li>
                      </ul>
                    </div>
                    <div className="d-flex gap-4">
                      <button className="theme-comm-btn"   type="button"
            // onClick={() => handleSubmit()} 
            onClick={() => handleSectionSubmit(values, "marketing")}
            >
                        Update
                      </button>
                    </div>
                  </div> */}
                </div>

              )}
              </Formik> 
              </div>
            </Col>
            <Col lg={4}></Col>
          </Row>
        </div>
      </Container>
    </Layout>
  );
}
